import axios from 'axios';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from './axios.helpers';

export const getClinics = async (pageNumber, pageSize) =>
  axiosGet(`/clinics?page[number]=${pageNumber + 1}&page[size]=${pageSize}`);

export const showClinic = async (id, includeTimes) => {
  const timesSuffix = includeTimes ? '?include=times' : '';
  return axiosGet(`/clinics/${id}${timesSuffix}`);
};

export const updateClinic = async (id, values, clinic, status) => {
  const {
    actualParticipants,
    bookingCutOffDaysNum,
    endDate,
    endTime,
    estimatedParticipants,
    multiDays,
    organizationId,
    schedulerId,
    serviceDuration,
    serviceId,
    startDate,
    startTime,
    subLocationId,
    concurrentSlots,
  } = values;

  const { booked_participants: bookedParticipants } = clinic;

  const submission = {
    actual_participants: actualParticipants,
    booked_participants: bookedParticipants,
    booking_cutoff_days_num: bookingCutOffDaysNum,
    end_date:
      multiDays === 1 ? moment(endDate).format('YYYY-MM-DD') : undefined,
    end_time: moment(endTime.split('-')[0], 'hh:mm').format('HH:mm'),
    estimated_participants: estimatedParticipants,
    organization_id: organizationId,
    service_duration: serviceDuration,
    service_id: serviceId,
    start_time: moment(startTime.split('-')[0], 'hh:mm').format('HH:mm'),
    start_date: moment(startDate).format('YYYY-MM-DD'),
    multi_days: multiDays,
    sublocation_id: subLocationId,
    status,
    concurrent_slots: concurrentSlots,
    ...(isEmpty(schedulerId.toString()) ? {} : { schedule_id: schedulerId }),
  };

  await axiosPatch(`/clinics/${id}`, submission);
};

export const updateClinicStatus = async (id, status) => {
  await axiosPatch(`/clinics/${id}/update-status`, {
    status,
  });
};

export const createClinic = async (clinic) => {
  const {
    organizationId,
    serviceId,
    subLocationId,
    schedulerId,
    multiDays,
    startDate,
    endDate,
    startTime,
    endTime,
    serviceDuration,
    estimatedParticipants,
    bookingCutOffDaysNum,
    concurrentSlots,
  } = clinic;

  await axiosPost('/clinics', {
    organization_id: organizationId,
    sublocation_id: subLocationId,
    service_id: serviceId,
    multi_days: multiDays,
    start_date: moment(startDate).format('YYYY/MM/DD'),
    end_date:
      multiDays === 1 ? moment(endDate).format('YYYY/MM/DD') : undefined,
    start_time: startTime,
    end_time: endTime,
    service_duration: serviceDuration,
    estimated_participants: estimatedParticipants,
    booking_cutoff_days_num: bookingCutOffDaysNum,
    concurrent_slots: concurrentSlots,
    ...(isEmpty(schedulerId.toString()) ? {} : { schedule_id: schedulerId }),
  });
};

export const toggleClinicStaff = async (clinicId, staffIds, assigned) => {
  await axiosPost('/clinics-staff', {
    clinic_id: clinicId,
    staff_id: staffIds,
    assigned,
  });
};

export const deleteClinic = async (id) => {
  await axiosDelete(`/clinics/${id}`);
};

const baseUrl = `${process.env.REACT_APP_API_URL}/v1`;
const token = localStorage.getItem('token');

export const getClinicSlots = async (clinic) => {
  const {
    sublocation_id: sublocationId,
    service_id: serviceId,
    schedule_id: scheduleId,
  } = clinic || {};

  return axios({
    method: 'get',
    url: `${baseUrl}/clinic-slots?sublocation_id=${sublocationId}&service_id=${serviceId}&schedule_id=${scheduleId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const toggleBlockSlots = async (clinicId, slots, type) => {
  const formattedSlots = slots.map(
    ({ key, start_date: startDate, end_date: endDate }) => ({
      key,
      start_date: startDate,
      end_date: endDate,
    }),
  );

  await axiosPost('/clinic-block-unblock-slot', {
    clinic_id: clinicId,
    type,
    slots: formattedSlots,
  });
};
